/** Preserve bookmarked transfer selection/recovery while leaving Compliance. */
export function legacyPhoneTransferSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  const section = params.get("section");
  if (
    section !== "transfers" &&
    (section || (!params.has("transferId") && !params.has("portOrderId")))
  )
    return null;
  params.delete("section");
  const remaining = params.toString();
  return remaining ? `?${remaining}` : "";
}
